import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOverleafComponent } from './simple-icons-overleaf.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOverleafComponent ],
    exports:      [ SimpleIconsOverleafComponent ],
    bootstrap:    []
})
export class SimpleIconsOverleafModule {}
